export const MANUAL = { value: "MANUAL", key: "billingPeriods.types.manual" };
export const RECURRING = {
  value: "RECURRING",
  key: "billingPeriods.types.recurring",
};

export default [MANUAL, RECURRING];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/billingPeriodTypes.js